/**
 * Parses a string value to a boolean.
 * Returns `true` for `"true"`, `false` for `"false"`, and `undefined` otherwise.
 */
export function parseStringBoolean(value: string | undefined): boolean | undefined {
  if (value === 'true') {
    return true;
  }

  if (value === 'false') {
    return false;
  }

  return undefined;
}
